<template>
<div class="chapter">
<div class="inner_page">
<div id="Front">
<div class="fig">
<p class="fig-img"><img alt="" class="image" src="images/ufig_2.jpg"/></p>
<p class="fig-caption">The bridge watch of <i>U-604</i> at work on stormy seas</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?64585beb